/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';

import { usePermissionStore } from '../../../models/usePermissionModel';
import common from '../../../utils/common';
import { PermissionNameEnum } from '@Types/permissions';
import Loading from '../Loading';
import NoPermission from '../NoPermission';
const PrivateRoute = ({
  children,
  readPermissionName,
  shouldBeAllScope = false,
}: {
  children: JSX.Element;
  readPermissionName: PermissionNameEnum[];
  shouldBeAllScope?: boolean;
}) => {
  if (!readPermissionName || readPermissionName.length === 0) {
    return children;
  }
  const { permissions, managementScopeIds } = usePermissionStore();
  if (!permissions) {
    return <Loading />;
  }
  if (readPermissionName) {
    const withReadPermission =
      common.withReadPermission(readPermissionName, permissions) &&
      (shouldBeAllScope ? managementScopeIds === 'all' : true);
    if (!withReadPermission) {
      // if (isInUIC()) {
      //   if (window.top?.location) {
      //     window.top.location.href = `/#/users/403`;
      //     return <></>;
      //   }
      // }
      return <NoPermission />;
    }
  }

  // if (!isAuthenticated) {
  //     return <Navigate to="/login" state={{ from: location }} />;
  // }

  return children;
};

export default PrivateRoute;
